import { gboReservationPath } from './session';

export const vehicleUpgradeFlagPath = [...gboReservationPath, 'upgrade_vehicle_possible'];
export const vehicleUpgradeDetailsPath = [...gboReservationPath, 'upgrade_car_class_details', 0];
